import React from 'react';
import { closeRegistrationForm, registerUser, validateErrorPassword, validateErrorNickname,
   clearErrorMessages, validateErrorEmail } from '../authSlice';
import './Registration.scss';
import  {validatePassword, validateEmail, validateNickname }  from '../../../helper/validation';


export default class Registration extends React.Component {
    constructor(props){
        super(props);
        this.state = {
           // userInputMail:'wscad@yandex.ru',
           // userInputPassword:'121212',
            userInputMail:'',
            userInputPassword:'',
            errorValidation:'',
            userInputNickName:'',
        }
        this.handleUserInputMail = this.handleUserInputMail.bind(this);
        this.handleUserInputPassword = this.handleUserInputPassword.bind(this);
        this.handleUserInputNickName = this.handleUserInputNickName.bind(this);
        this.onSend = this.onSend.bind(this);
        this.onClose = this.onClose.bind(this);
    }
    
//CLICK CONTINUE
onSend() {
    const {dispatch} = this.props;
    const item = {
       email: this.state.userInputMail,
       password: this.state.userInputPassword,
       nickname: this.state.userInputNickName,
       
      //  email: "wscad@yandex",
       // password: "121212"
    }
    console.log("press send");
    dispatch(registerUser(item));

}
//CLOSE FORM
onClose() {
 const {dispatch} = this.props;
 dispatch(closeRegistrationForm());
}

handleUserInputMail(e) {
    const {dispatch} = this.props;
    const message = validateEmail(e.target.value);
    dispatch(validateErrorEmail(message));
    dispatch(clearErrorMessages());
    
    this.setState({
        userInputMail: e.target.value
    })
}
handleUserInputPassword(e) {
    const {dispatch} = this.props;
    const message = validatePassword(e.target.value);
    dispatch(validateErrorPassword(message));
    dispatch(clearErrorMessages());

    this.setState({
        userInputPassword: e.target.value,
        errorValidation: message
    })
}

handleUserInputNickName(e) {
    const {dispatch} = this.props;
    const message = validateNickname(e.target.value);
    dispatch(validateErrorNickname(message));
    dispatch(clearErrorMessages());

    this.setState({
        userInputNickName: e.target.value,
        
    })
}

    render() {
        let style;
            
        if (/*!this.props.userData.errorMessage 
            &&*/ !this.props.userData.errorMessageEmail 
            && !this.props.userData.errorMessagePassword
            && this.state.userInputMail && this.state.userInputPassword && this.state.userInputNickName) {
          
                style = ''
            } else {
                style = 'disabled'
            }
        return (
            <div className="Registration">
                
                <h3>Регистрация</h3>
                    <div className='inputBlock'>
                        <input id="email" type="email" placeholder="Электронная почта" required 
                        value={this.state.userInputMail} onChange={this.handleUserInputMail} />

                    
                        <input type='password' id="password" placeholder="Пароль" required minLength ="5" 
                        value={this.state.userInputPassword} onChange={this.handleUserInputPassword}/>

                        <input placeholder='Ник' required minLength ="6" value={this.state.userNickName} 
                        onChange={this.handleUserInputNickName} />
                    </div>

                    <div className='errorBlock'>
                            <p id="error">{this.props.userData.errorMessageEmail}</p>
                            <p id="error">{this.props.userData.errorMessage}</p>
                            <p id="message">{this.props.userData.userMessage}</p>
                            <p id="error">{this.props.userData.errorMessagePassword}</p>
                            <p id="error">{this.props.userData.errorMessageNickname}</p>
                    </div>


                    <div className='buttonBlock'>
                            <button className='loginButton' onClick={this.onSend} disabled={style}>Регистрация</button>
                            {/* <p >Есть аккаунт?</p> */}
                            <button className='loginButton' onClick={this.onClose}>Отмена</button>
                           {/*  <button className='loginButton'>Вход</button>   */}
                    </div>

                
            </div>
        )
    }
}

/*
<button type="button" onClick={this.onSend}>Зарегистрироваться</button>
*/